/** Search input — magnifier + clear, designed not generic. */
import { forwardRef, useState } from "react";
import { Search, X } from "lucide-react";
import { cn } from "../../lib/cn";

export const SearchInput = forwardRef(function SearchInput(
  { className, value, defaultValue, onChange, onClear, placeholder = "Search…", testId = "search-input", ...props },
  ref
) {
  const [internal, setInternal] = useState(defaultValue || "");
  const v = value !== undefined ? value : internal;

  const handleChange = (e) => {
    if (value === undefined) setInternal(e.target.value);
    onChange?.(e);
  };

  const handleClear = () => {
    if (value === undefined) setInternal("");
    onClear?.();
    const ev = { target: { value: "" } };
    onChange?.(ev);
  };

  return (
    <div className={cn("relative", className)}>
      <Search
        size={16}
        className="absolute left-4 top-1/2 -translate-y-1/2 text-text-faint pointer-events-none"
      />
      <input
        ref={ref}
        type="text"
        value={v}
        onChange={handleChange}
        placeholder={placeholder}
        data-testid={testId}
        className="w-full bg-surface border border-line-2 text-text placeholder:text-text-faint rounded-full pl-11 pr-10 py-3 text-[14px] focus:outline-none focus:border-mauve focus:bg-surface-2 transition-colors"
        {...props}
      />
      {v && (
        <button
          type="button"
          onClick={handleClear}
          aria-label="Clear search"
          className="absolute right-3 top-1/2 -translate-y-1/2 w-7 h-7 rounded-full inline-flex items-center justify-center text-text-dim hover:text-text hover:bg-surface-2 transition-colors"
        >
          <X size={14} />
        </button>
      )}
    </div>
  );
});
